import { Box, BoxProps, styled } from '@mui/material'

const StyledPageContent = styled(Box)(() => ({
  paddingLeft: '25px',
  paddingRight: '25px',
  marginTop: '16px',
  paddingBottom: '3rem',
}))

export function PageContent(props: BoxProps) {
  return <StyledPageContent {...props}>{props.children}</StyledPageContent>
}
